import { Nav, Platform } from 'ionic-angular';
import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {} from 'jasmine';
//import { LoginPage } from '../pages/login/login';
import {LoginPage} from "../login/login";
import {SignUpPage} from "../signup/signup";
import {HomePage} from "../home/home";
//import { Paytm } from '@ionic-paytm/paytm';

@Component({
	selector: 'page-apphome',
	templateUrl: 'apphome.html'
})
export class AppHomePage implements OnInit {
	
	constructor(public navCtrl: NavController ) {}
	
	ngOnInit(){
		//window.plugins.paytm.startPayment("526", "25862", "abc@gmail.com", "777777777", "25", successCallback, failureCallback);
		var userids=window.localStorage.getItem('userid');
		//alert(userids);
		if(userids!= null)
		{
			this.navCtrl.push(HomePage);
		}
	}
	
	login()
	{
		this.navCtrl.push(LoginPage);
	}
	
	signup()
	{
		this.navCtrl.push(SignUpPage);
	}
	
	itemSelected()
	{
		this.navCtrl.push(HomePage);  
	}
	
	loginresirect() {
	}
	
}




// WEBPACK FOOTER //
// ./src/pages/apphome/apphome.ts